//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Bar from "../Bar.vue";
import Tag from "../Tag.vue";
export default {
	components: { Bar, Tag },
	name: "parliamentarian-list-item",
	props: {
		name: {
			type: String,
			required: true,
		},
		img: {
			type: String,
			required: true,
		},
	},
};
